import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-422603b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password-form" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-red mt-2"
}
const _hoisted_3 = { class: "flex flex-column gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "newPassword" }, [
  /*#__PURE__*/_createTextVNode("新しいパスワード"),
  /*#__PURE__*/_createElementVNode("small", { class: "required pl-2" }, "必須")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { id: "new-password-help" }, null, -1))
const _hoisted_6 = { class: "flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "passwordConfirmation" }, [
  /*#__PURE__*/_createTextVNode("パスワードを認証する"),
  /*#__PURE__*/_createElementVNode("small", { class: "required pl-2" }, "必須")
], -1))
const _hoisted_8 = { class: "flex flex-column gap-2 my-5" }

import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { ref, reactive, computed, onMounted } from "vue";
import rules from "./rules";
import { get, set } from "@vueuse/core";
import * as _ from "lodash";
import { ClinicService } from "../../services";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { useUrlSearchParams } from "@vueuse/core";
import { ValidateError } from "async-validator";
import type { ApiResetPasswordRequest } from "../../typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

const frmReset = ref<HTMLFormElement>();
const formResetPassword = reactive({ newPassword: "", passwordConfirmation: "", resetPasswordToken: "" });
const initValidation = computed(() => {
  return useAsyncValidator(formResetPassword, rules);
});
const validate = async (): Promise<boolean> => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);
const errorMessage = ref<string | null>(null);
const onError = (error: any) => {
  errorMessage.value = error.response?.data?.errors;
};
const onSuccess = () => {
  RouterUtils.goTo(RouterConstants.SIGN_IN_ROUTER_NAME);
};
const onSubmit = async () => {
  if (!(await validate())) return;

  await ClinicService.resetPassword(
    new FormData(get(frmReset) as unknown as HTMLFormElement) as unknown as ApiResetPasswordRequest,
    onSuccess,
    onError
  );
};

const backToSignIn = () => {
  RouterUtils.goTo(RouterConstants.SIGN_IN_ROUTER_NAME);
};
const getResetToken = computed(() => {
  const { token }: { token: string } = useUrlSearchParams("history");
  return token as string;
});
onMounted(() => {
  formResetPassword.resetPasswordToken = getResetToken.value;
});

return (_ctx: any,_cache: any) => {
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((!pass.value && errors.value?.length) || errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_.head(errors.value)?.message || errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      ref_key: "frmReset",
      ref: frmReset,
      class: "py-4 mx-auto"
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formResetPassword.resetPasswordToken) = $event)),
        class: "hidden",
        name: "reset_password_token"
      }, null, 512), [
        [_vModelText, formResetPassword.resetPasswordToken]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Password, {
          modelValue: formResetPassword.newPassword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formResetPassword.newPassword) = $event)),
          "aria-describedby": "new-password-help",
          type: "text",
          size: "large",
          name: "newPassword",
          placeholder: "新しいパスワード",
          class: _normalizeClass({ 'p-invalid': errorFields.value?.newPassword?.length }),
          inputProps: { name: 'password' },
          feedback: false,
          onInput: validate,
          toggleMask: ""
        }, null, 8, ["modelValue", "class"]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Password, {
          modelValue: formResetPassword.passwordConfirmation,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formResetPassword.passwordConfirmation) = $event)),
          "aria-describedby": "password-help",
          type: "text",
          size: "large",
          name: "passwordConfirmation",
          placeholder: "パスワードを認証する",
          class: _normalizeClass({ 'p-invalid': errorFields.value?.passwordConfirmation?.length }),
          inputProps: { name: 'password_confirmation' },
          feedback: false,
          onInput: validate,
          toggleMask: ""
        }, null, 8, ["modelValue", "class"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          label: "ログイン",
          class: "p-button-lg btn-primary",
          disabled: !pass.value,
          onClick: onSubmit
        }, null, 8, ["disabled"])
      ])
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(["back-to-sign-in text-right", { 'has-error': !pass.value && errorMessage.value }])
    }, [
      _createElementVNode("i", {
        onClick: backToSignIn,
        class: "pi pi-arrow-left"
      }, "ログインに戻る")
    ], 2)
  ]))
}
}

})